export const state = {
    profile: null,
}; 